import type { News } from '@/types/media';

export const newsList: News[] = [
  {
    id: 'news-01',
    title: '《星海远征》票房突破二十亿，科幻电影迎来新纪元',
    summary: '上映三周以来，《星海远征》凭借震撼的视觉奇观与动人的情感内核收获口碑票房双丰收，成为年度现象级科幻作品。',
    date: '2026-10-08',
    category: '行业动态',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20space%20movie%20scene%2C%20astronaut%20looking%20at%20distant%20glowing%20galaxy%2C%20epic%20deep%20blue%20and%20orange%20tones%2C%20grand%20sci-fi%20atmosphere&width=800&height=500&seq=news-01&orientation=landscape',
    content: [
      '上映三周，《星海远征》的累计票房正式突破二十亿大关，成为本年度最具话题度的科幻影片之一。影片以其恢弘的宇宙想象和细腻的情感表达，赢得了观众与影评人的一致好评。',
      '导演克里斯·诺兰在采访中表示，创作这部作品最大的挑战在于如何让宏大的科学设定服务于人物的情感。团队历时四年打磨剧本，并邀请了多位天体物理学家担任顾问。',
      '有分析人士指出，《星海远征》的成功或将带动新一轮科幻题材的投资热潮。多家影视公司已宣布启动各自的科幻项目，市场对高质量原创科幻内容的期待值正在持续攀升。',
    ],
  },
  {
    id: 'news-02',
    title: '国产悬疑剧持续升温，《长安秘事》口碑登顶',
    summary: '古装悬疑剧《长安秘事》开播以来热度居高不下，精良的制作与缜密的剧情让它成为近期评分最高的国产剧集。',
    date: '2026-10-06',
    category: '剧集',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20night%20scene%20with%20glowing%20lanterns%20and%20pagodas%2C%20mysterious%20deep%20blue%20and%20gold%20tones%2C%20cinematic%20historical%20drama%20mood&width=800&height=500&seq=news-02&orientation=landscape',
    content: [
      '古装悬疑剧《长安秘事》自上线以来热度持续走高，凭借考究的服化道、环环相扣的剧情以及演员扎实的表演，迅速积累了大批忠实观众。',
      '该剧以唐代长安为背景，通过一桩桩离奇案件串起庞大的故事网络。编剧团队表示，创作过程中查阅了大量史料，力求在虚构与真实之间找到平衡。',
      '业内人士认为，观众的审美正在不断提升，对剧本逻辑与制作水准的要求越来越高。优质内容的竞争，正在成为剧集市场的新常态。',
    ],
  },
  {
    id: 'news-03',
    title: '第38届国际电影节公布入围名单，多部华语影片入选',
    summary: '本届电影节主竞赛单元入围名单揭晓，多部华语作品榜上有名，题材涵盖剧情、动画与纪录片，展现华语电影的多元面貌。',
    date: '2026-10-04',
    category: '电影节',
    cover: 'https://readdy.ai/api/search-image?query=Film%20festival%20red%20carpet%20scene%20with%20spotlights%20and%20elegant%20crowd%2C%20glamorous%20gold%20and%20deep%20blue%20tones%2C%20prestigious%20celebratory%20atmosphere&width=800&height=500&seq=news-03&orientation=landscape',
    content: [
      '第38届国际电影节近日公布了主竞赛单元的入围名单，多部华语影片成功入选，涵盖剧情、动画、纪录片等多种类型。',
      '评委会主席在发布会上表示，本届入围作品在题材与表达上都展现出令人惊喜的多样性，尤其是年轻导演的创作活力令人印象深刻。',
      '电影节将于下月正式开幕，届时将举办多场展映与行业论坛。多部入围影片的主创团队预计将出席红毯与首映活动。',
    ],
  },
  {
    id: 'news-04',
    title: '动画电影《机器人小新》定档，合家欢题材受关注',
    summary: '备受期待的动画电影《机器人小新》正式宣布定档，温馨治愈的故事与精良的制作让它成为亲子观影的热门选择。',
    date: '2026-10-02',
    category: '动画',
    cover: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20family%20movie%20scene%2C%20cute%20friendly%20robot%20and%20child%20playing%20together%2C%20bright%20cheerful%20playful%20cartoon%20style&width=800&height=500&seq=news-04&orientation=landscape',
    content: [
      '动画电影《机器人小新》正式宣布定档，影片讲述了一个小机器人与男孩之间的温暖友谊故事，主打合家欢与治愈路线。',
      '制作团队在采访中透露，影片的美术风格历经多轮打磨，力求在色彩与造型上兼顾儿童的喜爱与成人的审美。',
      '业内观察者认为，随着家庭观影需求的增长，高质量的合家欢动画正在成为市场的重要增长点，未来竞争将更加激烈。',
    ],
  },
  {
    id: 'news-05',
    title: '流媒体平台加码原创内容，影视行业格局生变',
    summary: '多家流媒体平台宣布加大原创影视投入，从剧集到电影全面布局，传统制作与发行模式正面临深刻变革。',
    date: '2026-09-30',
    category: '行业动态',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20media%20concept%2C%20abstract%20digital%20screens%20with%20film%20content%20floating%2C%20clean%20blue%20and%20orange%20tech%20tones%2C%20futuristic%20communication%20mood&width=800&height=500&seq=news-05&orientation=landscape',
    content: [
      '流媒体平台正以前所未有的力度加码原创影视内容。近日，多家平台公布了各自的年度内容计划，原创剧集与电影成为投入重点。',
      '与传统影视公司相比，流媒体平台更依赖数据驱动的创作决策，同时对题材创新与全球化发行有着更强的诉求。',
      '分析人士指出，内容竞争的白热化将推动行业整体制作水准的提升，但如何平衡投入产出、避免同质化，仍是平台需要面对的课题。',
    ],
  },
  {
    id: 'news-06',
    title: '《峰顶之巅》幕后特辑曝光，实景拍摄挑战极限',
    summary: '动作冒险片《峰顶之巅》发布幕后制作特辑，剧组深入高海拔雪山实景拍摄，演员徒手攀爬的镜头引发热议。',
    date: '2026-09-27',
    category: '幕后',
    cover: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20mountain%20climbing%20film%20production%2C%20film%20crew%20with%20cameras%20on%20snowy%20peak%2C%20cold%20crisp%20blue%20and%20white%20tones%2C%20adventurous%20documentary%20feel&width=800&height=500&seq=news-06&orientation=landscape',
    content: [
      '动作冒险片《峰顶之巅》发布了一段幕后制作特辑，展示了剧组在高海拔雪山实景拍摄的艰辛过程，引发观众广泛讨论。',
      '据制片方介绍，为了追求真实感，主演们接受了长达半年的攀岩与体能训练，绝大部分高难度镜头均由演员亲自完成。',
      '这种坚持实景拍摄的做法获得不少业内人士的赞赏，也再次引发了关于特效与实拍如何取舍的讨论。',
    ],
  },
  {
    id: 'news-07',
    title: '年代剧回暖，观众为何钟情“慢节奏”故事',
    summary: '从《庄园风云》到《山城烟火》，一批节奏舒缓、注重人物刻画的作品走红，折射出观众审美的悄然转变。',
    date: '2026-09-24',
    category: '影评',
    cover: 'https://readdy.ai/api/search-image?query=Nostalgic%20period%20drama%20scene%2C%20cozy%20old%20town%20street%20with%20warm%20lamplight%20and%20flowers%2C%20muted%20green%20and%20amber%20tones%2C%20reflective%20emotional%20mood&width=800&height=500&seq=news-07&orientation=landscape',
    content: [
      '近两年，一批节奏舒缓、以人物塑造为核心的年代剧与家庭剧重新受到观众青睐，成为荧屏上的亮眼风景。',
      '与强情节的爽剧不同，这些作品更愿意花时间描绘生活的细节与人物的内心。有观众表示，这样的“慢”反而让人感到治愈。',
      '评论者认为，这种转变与观众对内容深度的需求提升密切相关。当快节奏的刺激逐渐审美疲劳，回归生活与情感的叙事更能触动人心。',
    ],
  },
  {
    id: 'news-08',
    title: '影视配音行业迎来新变化，AI技术引发讨论',
    summary: '人工智能配音技术快速发展，在提升效率的同时也引发对创作者权益的讨论，行业正在探索规范与共赢之路。',
    date: '2026-09-20',
    category: '技术',
    cover: 'https://readdy.ai/api/search-image?query=Audio%20recording%20studio%20concept%20with%20microphone%20and%20sound%20waveform%20displays%2C%20clean%20modern%20blue%20and%20orange%20tones%2C%20professional%20technical%20atmosphere&width=800&height=500&seq=news-08&orientation=landscape',
    content: [
      '人工智能技术正加速渗透影视制作环节，配音成为最新的应用场景之一。部分公司已开始尝试用 AI 完成初步的语音合成与本地化工作。',
      '支持者认为，AI 配音能显著降低成本、加快制作周期；而配音演员则担忧，技术滥用可能侵蚀他们的工作机会与创作权益。',
      '目前，多个行业协会正在推动相关规范的建立，希望在拥抱技术的同时，保护创作者的合法权益，实现行业的健康可持续发展。',
    ],
  },
];